import { catchFetchApiError, fetchApi, getFetchApiJSONResponse } from 'shared/functions';
import { CollectionType } from '../../types';

export const fetchInitialFiltersData = (portfolioId: string, collection: CollectionType) =>
  fetchApi(`/user-profile/portfolios/filter-fields/${portfolioId}/${collection}`)
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
